<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{ editRoute ? $t('labels.edit_hazard') : $t('labels.add_hazard') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full mb-4 p-0">
              <label>{{$t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="hazard_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.hazard_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('hazard_name') }}</span>
            </div>
          </div>
          <div class="mt-2 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-hazard"
              button="submit"
            >{{ editRoute ? $t('labels.update_hazard') : $t('labels.add_hazard') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: ""
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.setValidationMessage();
    if (this.editRoute) {
      this.getHazards();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateHazards();
        }
      });
    },
    // API Integration for add-update designation
    async createUpdateHazards() {
      let input = {
        name: this.name
      };
      let url = this.editRoute
        ? "/hazards/update/" + this.editRoute
        : "/hazards/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-hazard",
        true
      );
      if (response) {
        this.$router.push({ name: "Hazards" });
      }
    },
    async getHazards() {
      let response = await this.getHTTPGetResponse(
        "/hazards/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let hazard = data.hazard;
        this.name = hazard.name;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>